import React from "react";
import { Link } from "react-router-dom";
import './footer.css';

function Footer() {
    return (
        <div className="footer">
            <div style={{paddingBottom: '1.5vmax', display: "flex", justifyContent: 'space-between'}}>
                <div className="footLogo">
                    <img src="https://ik.imagekit.io/nvo8yi18o/VETOMAC/Navbar/iitrLogo_gTlR1gpMI.svg?updatedAt=1679926585447" />
                    <p className="copyright">Indian Institute of Technology, Roorkee</p>
                </div>
                <div className="links">
                    <h3 className="footTitle">Quick Links</h3>
                    <div className="footLinks" style={{display: 'flex', flexDirection: 'column'}}>
                        <Link to="/registration">Registration</Link>
                        <Link to="/abstracts">Call for Abstracts</Link>
                        <Link to="/keynotes">Keynotes</Link>
                        <Link to="/committees">Committees</Link>
                        <Link to="/contact">Contact</Link>
                    </div>
                </div>
                <div className="socials">
                    <h3 className="footTitle">Socials</h3>
                    <div className="footLinks" style={{display: 'flex', flexDirection: 'column'}}>
                        <a href="https://twitter.com/iitroorkee/" target="_blank" rel="noopener noreferrer">Twitter</a>
                        <a href="https://www.facebook.com/IITRoorkee.ICC" target="_blank" rel="noopener noreferrer">Facebook</a>
                        <a href="https://www.instagram.com/iitroorkee/" target="_blank" rel="noopener noreferrer">Instagram</a>
                    </div>
                </div>
            </div>
            <div className="divider"></div>
            <div className="copyright">
                ©2023 IIT Roorkee. All rights reserved
            </div>
        </div>
    )
}

export default Footer;